// extracted by mini-css-extract-plugin
module.exports = {"searchBox":"SearchBtn_searchBox__Q1i5w","inputSearch":"SearchBtn_inputSearch__3uCkx","btnSearch":"SearchBtn_btnSearch__1fzfv"};